



































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import NumUtils from "@/utils/numUtils";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class TitleSection extends Vue {
  @Getter(types.GETTER_MASTER_COINS)
  private userCoins: any;
  @Getter(types.GETTER_CURRENT_FEED)
  private currentFeed: any;
  @Getter(types.GETTER_EARN_COIN_USER_LIST)
  private earnCoinUserList: any;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;

  get format() {
    return NumUtils.format;
  }

  get userList() {
    return this.earnCoinUserList("all").slice(0,4);
  }

  get restrictedUserList() {
    return this.earnCoinUserList("restricted");
  }

  get bannedUserList() {
    return this.earnCoinUserList("banned");
  }

  get title() {
    const subKind = this.currentFeed ? this.currentFeed.sub_kind : null;
    switch (subKind) {
      case "follow": {
        return "start to follow";
      }
      case "like": {
        return "start to like";
      }
      case "comment": {
        return "start to comment";
      }
      default: {
        return "start to follow";
      }
    }
  }

  private clickUserIconWrappe() {
    this.routerPush({
      name: "TurboMode",
      params: {
        routerTransition: "forward"
      }
    });
  }

  private dynamicStyle(index: any, list: any) {
    console.log("dynamicStyle:", index, list);
    return { zIndex: list.length - index };
  }

  private warningMaskShow(userData: any) {
    for (const user of this.restrictedUserList) {
      if (user.userId === userData.userId) {
        return true;
      }
    }

    for (const user of this.bannedUserList) {
      if (user.userId === userData.userId) {
        return true;
      }
    }

    return false;
  }
}
